import { Shield, UserCog, Wrench } from "lucide-react";
import type { Role } from "@/domains/auth/api/types";

export const ROLE_LABELS: Record<Role, string> = {
  requester: "Aanvrager",
  manager: "Beheerder",
  partner: "Externe partner",
};

export const ROLE_ICONS: Record<Role, React.ComponentType<{ className?: string }>> = {
  requester: UserCog,
  manager: Shield,
  partner: Wrench,
};
